import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const AdditionalPhoneCellContent: React.FC<
	AdditionalPhoneCellContent.Props
> = ({ item }) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.AdditionalPhone];

		if (isCellsReady && preparedCell) {
			return preparedCell;
		}

		return cellProcessing(item.phones);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item?.phones,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace AdditionalPhoneCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default AdditionalPhoneCellContent;
